/* eslint-disable @typescript-eslint/no-explicit-any */
import Client from "shared/services/Client";
import { ELOQUA_LEAD_SOURCE_VALUES } from "common/constants/Constants";

interface AbandonedCartData {
    email: string;
    [key: string]: any;
}

function sendEmailToEloquaAndCpref(email: string, leadSource: ELOQUA_LEAD_SOURCE_VALUES,
    setStatusUnverified?: boolean): Promise<any> {
    return Client.post("/api/marketing/", {
        email,
        leadSource,
        setStatusUnverified
    });
}

function updateAbandonedCartStatus(data: AbandonedCartData): Promise<any> {
    const { email } = data;

    return Client.put(`/api/marketing/${ email }/update-abandoned-cart-status`, data);
}

function sendOptOutToCpref(email: string, isOptedIn: boolean): Promise<any> {
    return Client.put("/api/marketing/update-marketing-options", {
        email,
        status: isOptedIn
    });
}

export default {
    sendEmailToEloquaAndCpref,
    updateAbandonedCartStatus,
    sendOptOutToCpref
};
